import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
    createColumnHelper,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable
} from '@tanstack/react-table'
import TableListing from '../../TableListing/TableListing'
import { ReactComponent as IconView } from '../../../assets/images/icons/icon-view-white.svg'
import { ReactComponent as IconDelete } from '../../../assets/images/icons/icon-delete-white.svg'
import { ReactComponent as IconsDots } from '../../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconApproveRight } from '../../../assets/images/icons/icon-right-aprrove.svg'
import { ReactComponent as IconDesapproveClose } from '../../../assets/images/icons/icon-close-desaprrove.svg'
import TableSkeleton from '../../TableSkeleton/TableSkeleton'
import { productcatalog} from '../../../config/routingConsts'
import { useNavigate } from 'react-router-dom'
import requestApi from '../../../utils/request'
import { useMutation,useQuery,useQueryClient } from '@tanstack/react-query'
import PaginationItem from '../../Pagination/Pagination'
import DeleteModal from '../../DeleteModal/DeleteModal'
import NoRecordFound from '../../NoRecordFound/NoRecordFound'
import ApproveDeclinePopup from '../../ApproveDeclinePopup/ApproveDeclinePopup'
import Swal from 'sweetalert2'


//#region get All Main Category
const getAllReasons = async () => {
    const reasons = await requestApi.post(
        '/catalog/decline-reasons'
    )
    return reasons.data
}
//#endregion

const TabwithStatusFilter = ({
    id,
    content,
    loading,
    totalcount,
    getpage,
    searchKeyword,
    setSearchKeyword
}) => {
       
    //#region  Main-category Listing
        const { data: ReasonList, isLoading } = useQuery({
            queryKey: ['maincategorylist'],
            queryFn: getAllReasons
        })
    //#endregion
       
        const[reason,setReason]=useState()

    const [buttonText, setButtonText] = useState('')
    const [statusUpdate, setStatusUpdate] = useState(null)

    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [openAction, setopenAction] = useState(null)
    const [sorting, setSorting] = useState([])
    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [deleteId, setDelteId] = useState('')
    const queryClient = useQueryClient()
    const EditDataRef = useRef(null)
    const [ShowMaterialStatusPopup, setShowMaterialStatusPopup] =
        useState(false)
        const [ShowReportModalPopup,setShowReportModalPopup] = useState(false)
    const [noteText, setnoteText] = useState('')

    const navigate = useNavigate()

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
            if (typeof getpage == 'function') getpage(currentPage)
        },
        [currentPage]
    )

    useEffect(() => {
        return () => getpage(1)
    }, [])

    const OpenAction = (id) => {
        setopenAction(openAction === id ? null : id)
    }

    const handleDeleteModal = (id) => {
        setIsDeleteModal(true)
        setDelteId(id)
    }

    //#region Catalog Table- Columns
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.accessor((row) => row?.productUniqueId, {
            id: 'productUniqueId',
            header: () => 'Product ID',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.productUniqueId
                            ? row?.row?.original?.productUniqueId
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.productName, {
            id: 'productName',
            header: () => 'Product Name',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.productName
                            ? row?.row?.original?.productName
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.sellerName, {
            id: 'sellerName',
            header: () => 'Vendor Name',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.sellerName
                            ? row?.row?.original?.sellerName
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.mainCategoryName, {
            id: 'mainCategoryName',
            header: () => 'Category',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.mainCategoryName
                            ? row?.row?.original?.mainCategoryName
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.categoryName, {
            id: 'categoryName',
            header: () => 'Sub-Category',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.categoryName
                            ? row?.row?.original?.categoryName
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.type, {
            id: 'type',
            header: () => 'Type',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.type
                            ? row?.row?.original?.type
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.materialName, {
            id: 'materialName',
            header: () => 'Material',
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.materialName
                            ? row?.row?.original?.materialName
                            : '-'}
                    </span>
                )
            }
        }),
        columnHelper.accessor((row) => row?.shippingTime, {
            id: 'shippingTime',
            header: () => 'Shipping Time',
            enableSorting: false,
            cell: (row) => {
                return (
                    <span>
                        {row?.row?.original?.shippingTime
                            ? row?.row?.original?.shippingTime
                            : '-'}
                    </span>
                )
            }
        }),

        columnHelper.display({
            id: 'Action',
            header: () => 'Actions',
            cell: (row) => {
                switch (row?.row?.original?.status) {
                    case 1:
                        return (
                            <div
                                className={`table-action ${
                                    row?.row?.original?.id === openAction
                                        ? 'active'
                                        : ''
                                }`}
                                onMouseLeave={() => setopenAction(null)}
                            >
                                <div
                                    className={`action-btn ${
                                        row?.row?.original?.id === openAction
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        OpenAction(row?.row?.original?.id)
                                    }
                                >
                                    <IconsDots />
                                </div>
                                <div className="action-panel two-action">
                                    <div
                                        className="action-btn-icon edit"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="View"
                                        onClick={() =>
                                            navigate(
                                                `${productcatalog}/${row?.row?.original?.id}`
                                            )
                                        }
                                    >
                                        <IconView />
                                    </div>
                                    <div
                                        className="action-btn-icon delete"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Delete"
                                        onClick={() =>
                                            handleDeleteModal(
                                                row?.row?.original?.id
                                            )
                                        }
                                    >
                                        <IconDelete />
                                    </div>
                                </div>
                            </div>
                        )
                    case 7:
                        return (
                            <>
                                <div
                                    className={`table-action ${
                                        row?.row?.original?.id === openAction
                                            ? 'active'
                                            : ''
                                    }`}
                                    onMouseLeave={() => setopenAction(null)}
                                >
                                    <div
                                        className={`action-btn ${
                                            row?.row?.original?.id ===
                                            openAction
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            OpenAction(row?.row?.original?.id)
                                        }
                                    >
                                        <IconsDots />
                                    </div>
                                    <div className="action-panel three-action">
                                        <div
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="View"
                                            className="action-btn-icon edit"
                                            onClick={() =>
                                                navigate(
                                                    `${productcatalog}/${row?.row?.original?.id}`
                                                )
                                            }
                                        >
                                            <IconView />
                                        </div>

                                        <div
                                            className="action-btn-icon edit"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Aprrove"
                                            onClick={() => {
                                                handleApproveDecline(
                                                    row?.row?.original?.id,
                                                    // setButtonText("Approve")
                                                    setButtonText(
                                                        'Approve Product'
                                                    )
                                                )
                                            }}
                                        >
                                            <IconApproveRight />
                                        </div>

                                        <div
                                            className="action-btn-icon delete"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Decline"
                                            onClick={() => {
                                                handleApproveDecline(
                                                    row?.row?.original?.id,
                                                    // setButtonText("Decline")
                                                    setButtonText(
                                                        'Decline Product'
                                                    )
                                                )
                                            }}
                                        >
                                            <IconDesapproveClose />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    case 5:
                        return (
                            <div
                                className={`table-action ${
                                    row?.row?.original?.id === openAction
                                        ? 'active'
                                        : ''
                                }`}
                                onMouseLeave={() => setopenAction(null)}
                            >
                                <div
                                    className={`action-btn ${
                                        row?.row?.original?.id === openAction
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        OpenAction(row?.row?.original?.id)
                                    }
                                >
                                    <IconsDots />
                                </div>
                                <div className="action-panel two-action">
                                    <div
                                        className="action-btn-icon edit"
                                        onClick={() =>
                                            navigate(
                                                `${productcatalog}/${row?.row?.original?.id}`
                                            )
                                        }
                                    >
                                        <IconView />
                                    </div>
                                    <div
                                        className="action-btn-icon delete"
                                        //  onClick={() =>
                                        //     handleDeleteModal(
                                        //          row?.row?.original?._id
                                        //     )
                                        //   }
                                    >
                                        <IconDelete />
                                    </div>
                                </div>
                            </div>
                        )
                    default:
                        return (
                            <>
                                <div
                                    className={`table-action ${
                                        row?.row?.original?.id === openAction
                                            ? 'active'
                                            : ''
                                    }`}
                                >
                                    <div
                                        className={`action-btn ${
                                            row?.row?.original?.id ===
                                            openAction
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            OpenAction(row?.row?.original?.id)
                                        }
                                    >
                                        <IconsDots />
                                    </div>
                                    <div className="action-panel two-action">
                                        <div
                                            className="action-btn-icon edit"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="View"
                                            onClick={() =>
                                                navigate(
                                                    `${productcatalog}/${row?.row?.original?.id}`
                                                )
                                            }
                                        >
                                            <IconView />
                                        </div>
                                        <div
                                            className="action-btn-icon delete"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Delete"
                                            onClick={() =>
                                                handleDeleteModal(
                                                    row?.row?.original?.id
                                                )
                                            }
                                        >
                                            <IconDelete />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                }
            }
        })
    ]
    //#endregion

    const table = useReactTable({
        data: content || [],
        columns: columns,
        state: {
            sorting
        },
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    useEffect(() => {
        if (currentPage && content?.length == 0) {
            setCurrentPage(currentPage - 1)
        }
    }, [currentPage, content])

    useEffect(() => {
        setCurrentPage(1)
    }, [searchKeyword])

    //#region  delete catalog 
    function handleDelete(catalogId) {
        mutationDelete.mutate(catalogId)
        setIsDeleteModal(false)
    }

    async function deleteCatalogId(catalogId) {
        return await requestApi.post(`catalog/delete`, {
            catalogId
        })
    }

    const mutationDelete = useMutation(deleteCatalogId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('cataloglist')
            setIsDeleteModal(false)
            EditDataRef.current = null
        },
        onError: (error) => {
            EditDataRef.current = null
            // Swal.fire({
            //   position: "center",
            //   icon: "error",
            //   title: "",
            //   text: error?.message,
            // });
        }
    })
    //#endregion

    //#region Approve/Decline Catalog
    const handleApproveDecline = (id) => {
        setShowMaterialStatusPopup(true)
        setStatusUpdate(id)
    }

    function handlePermission(catalogId,callback) {
        console.log(catalogId,'catalogId')
        mutationStatusUpdate.mutate(catalogId,callback)
        setShowMaterialStatusPopup(false)
    }

    async function updateStatusbyId(catalogId,callback) {
        if (buttonText == 'Approve Product') {
            return await requestApi.post(`/catalog/approve-decline`, {
                ...catalogId,
                status: 1
            })
        } else {
            return await requestApi.post(`/catalog/approve-decline`, {
                ...catalogId,
                status: 5,
                note: noteText
            }).then((e)=>{
                if (callback==="function") {
                    callback()
                } 
                return e
            })
        }
    }
    const mutationStatusUpdate = useMutation(updateStatusbyId, {
        onSuccess: ({ data }) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            })
            queryClient.invalidateQueries('catalogList')
            setShowMaterialStatusPopup(false)
            setShowReportModalPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    //#endregion

    return (
        <>
            {loading ? (
                <TableSkeleton />
            ) : content?.length > 0 ? (
                <>
                    <TableListing
                        table={table}
                        className="m-0"
                        parentLink={productcatalog}
                        keyValue="id"
                        isLink
                        excludes={['Action']}
                    />
                    <div className="pagination-wrap">
                        <div className="showing-pages">
                            <span>
                                Showing {(currentPage - 1) * DataLimit + 1} to{' '}
                                {Math.min(currentPage * DataLimit, totalcount)}{' '}
                                of {totalcount}{' '}
                                {totalcount > 1 ? 'Products' : 'Product'}
                            </span>
                        </div>
                        {totalcount > 10 && (
                            <>
                                {/* <div className="itemperpage-box">
                          <span>Items per page:</span>

                          <Dropdown onSelect={handleChange}>
                              <Dropdown.Toggle
                                  variant="success"
                                  id="dropdown-basic"
                              >
                                  {DataLimit}
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                  <Dropdown.Item eventKey="10">
                                      10
                                  </Dropdown.Item>
                                  <Dropdown.Item eventKey="20">
                                      20
                                  </Dropdown.Item>
                                  <Dropdown.Item eventKey="30">
                                      30
                                  </Dropdown.Item>
                              </Dropdown.Menu>
                          </Dropdown>
                      </div> */}

                                <PaginationItem /* Pagination Component */
                                    total={Math.ceil(totalcount / DataLimit)}
                                    current={currentPage}
                                    onChangePage={handleChangePage}
                                />
                            </>
                        )}
                    </div>
                </>
            ) : (
                <div className="no-record-found">
                    <NoRecordFound />
                </div>
            )}

            <DeleteModal
                message={
                    <>
                        Are you sure you want to <br /> Delete this Product ?
                    </>
                }
                setIsDeleteModal={setIsDeleteModal}
                isDeleteModal={isDeleteModal}
                handleDelete={() => handleDelete(deleteId)}
            />

            <ApproveDeclinePopup
                ShowMaterialStatusPopup={ShowMaterialStatusPopup}
                setShowMaterialStatusPopup={setShowMaterialStatusPopup}
                setStatusUpdate={statusUpdate}
                title={`Are you sure you want to ${buttonText} ?`}
                // handlestatus={handlestatus}
                text={buttonText}
                noteText={noteText}
                setnoteText={setnoteText}
                handlePermission={(a,callback) => handlePermission({...a,catalogId:statusUpdate},callback)}
                ShowReportModalPopup={ShowReportModalPopup}
                setShowReportModalPopup={setShowReportModalPopup}
                ReasonList={ReasonList}
                reason={reason} 
                setReason={setReason} 
            />
        </>
    )
}

export default React.memo(TabwithStatusFilter)
